import { ModuleTree } from "vuex"
import { State } from "@/models"
import {
    CountryModuleNamespace,
    CompanyModuleNamespace,
    MarketModuleNamespace,
    VenueModuleNamespace,
    SmartBoxModuleNamespace,
    VersionModuleNamespace,
} from "@/consts"
import CountryModule from "./country"
import CompanyModule from "./company"
import MarketModule from "./market"
import VenueModule from "./venue"
import SmartBoxModule from "./smartbox"
import VersionModule from "./version"

const modules: ModuleTree<State> = {
    [CountryModuleNamespace]: CountryModule,
    [CompanyModuleNamespace]: CompanyModule,
    [MarketModuleNamespace]: MarketModule,
    [VenueModuleNamespace]: VenueModule,
    [SmartBoxModuleNamespace]: SmartBoxModule,
    [VersionModuleNamespace]: VersionModule,
}

export default modules
